// tslint:disable: variable-name
export default class LeaseInvoice {
    // LI_TG is the primary key
    li_tg: number;
    ls_no: number;
    invoice_no1?: number;
    invoice_no2?: number;
    invoice_no3?: number;
    bonus1?: number;
    bonus2?: number;
    bonus_down?: number;
    bank1?: number;
    bank2?: number;
    fwd_bank1?: number;
    fwd_bank2?: number;
    rec_fee?: number;
    adv_rental?: number;
    other?: number;
    add_other?: number;
    tot_bonus?: number;
    collection1?: string;
    collection2?: string;
    draft1?: number;
    draft2?: number;
    check1?: number;
    check2?: number;
    inv_date?: Date;
    due_date1?: Date;
    due_date2?: Date;
    chk_date1?: Date;
    chk_date2?: Date;
    rec_date?: Date;
    assign_date?: Date;
    tran_date?: Date;
    book?: string;
    page?: string;
    comm1?: string;
    comm2?: string;
    attach?: string;
    use_book?: string;
    invoice_add?: string;
    ih_date?: Date;
    mod_by?: string;
    mod_dt?: Date;
    ar_date?: Date;
    lease_ih_date?: Date;
    check_sent_date?: Date;
    pooling_date?: Date;
    collection_date?: Date;
    collection_flag?: number;
    void_date?: Date;
    bad_debt?: number;
    bad_debt_date?: Date;
    bad_debt_gl?: Date;
    refund_amt?: number;
    refund_date?: Date;
    bad_debt_reason?: string;
    lease_row_id?: number;
    row_code?: number;

    // not mapped
    static fullNumber = (invoice: LeaseInvoice) => {
        let num = invoice.invoice_no1.toString();
        if (invoice.invoice_add !== null && invoice.invoice_add !== '') {
            num += '-' + invoice.invoice_add;
        }
        return num;
    }

    static forTest = (id: number, leaseNumber: number): LeaseInvoice => {
        let test: LeaseInvoice = {
            ls_no: leaseNumber,
            invoice_no1: 132488,
            rec_fee: 29.00,
            rec_date: new Date('08/11/2025'),
            check1: 2024112201,
            inv_date: new Date('2024-11-21'),
            due_date1: new Date('2024-12-05'),
            due_date2: new Date('2024-11-29'),
            chk_date1: new Date('2024-11-22'),
            use_book: 'Y',
            invoice_add: 'A',
            li_tg: id,
            mod_by: 'Chris T. Foster',
            mod_dt: new Date('2024-11-21'),
            ar_date: new Date('2024-11-21'),
            collection_flag: 2
        };

        return test;
    }
}


// WEBPACK FOOTER //
// ./src/models/dlcLease/LeaseInvoice.ts